<template>
    <div>
      <h2>등하원 메시지 발송</h2>
      <p>
        부모에게 등하원 메시지를 전송하는 일은 학원업무의 기본입니다.<br/>
        핵심은 등하원 메시지를 얼마나 편하게 전송할 수 있는가 입니다. <br/>
        Tens에듀에서는 다음의 2가지 상황으로 등하원 메시지를 보낼 수 있습니다.<br/>
        또한 학생앱을 통한 Qr코드를 이용한 등하원 발송이 있습니다.<br/>
      </p>
      <p>
        등하원 메시지 발송은 문자 서비스 api가 등록되어야 사용 가능합니다.<br/>
        출결체크는 메시지 발송과는 별개이므로, 강사가 체크해야 합니다.
      </p>
      
      <section>
        <div class="p-relative section_0" id="check_by_teacher">
            <div class="ft-b">1)    선생님이 등하원 발송</div>
            
            <div class="p-relative section_1">
                - 선생님이 등하원 발송하는 페이지는 다음의 두군데에서 발송할 수 있습니다.
                a.  홈화면
                b.  수업관리 > 오늘수업
            </div>

            <p></p>
            <div class="p-relative section_2">
                a. 홈화면에서는 학원전체의 오늘 수업 진행을 볼 수 있으며, 내 수업이 아닌 다른 선생님의 수업을 볼 수 있습니다.
            </div>

            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_in_home.jpg" /></div>
            </div>
            
            <div class="p-relative section_2">
                수업하는 반의 “출결”버튼을 클릭하여, 학생목록을 불러옵니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_modal.jpg" /></div>
            </div>
            
            <div class="p-relative section_2">
                다음으로는 등하원발송하기를 원하는 학생의 “문자”버튼을 클릭하여 “등원”,”하원”발송을 클릭합니다.<br/>
                문자발송은 오늘날짜에만 발송할 수 있습니다.<br/>
                홈화면의 오늘 수업은 과거 날짜의 수업을 가져올 수 있기 때문에 자칫 잘못하면 과거 날짜의 수업에서 등하원 문자를 발송하는 경우를 방지하기 위함입니다.<br/>
            </div>

            <div class="p-relative section_2">
                b. “수업관리 > 오늘수업”에서 등하원 문자를 발송할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_in_class.jpg" /></div>
            </div>

            <div class="p-relative section_2">
                홈화면과 동일하게 “출결”버튼을 클릭하여 보내려고 하는 학생의 등하원 메시지를 보낼 수 있습니다.
            </div>

            <div class="p-relative section_2">
                홈화면과의 차이점은 “수업관리 > 오늘수업” 화면에서는 내가 수업하는 수업에 대해서만 수업이 나열되므로 다른 반의 학생에 대한 출결을 보낼 수 없습니다.
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="check_by_student">
            <div class="ft-b">2)    학생이 등하원 발송</div>
            
            <div class="p-relative section_1">
                - Tens에듀에서는 등하원 문자를 학생이 스스로 할 수 있는 기능을 갖고 있습니다. <br/>
                태블릿을 데스크에 마련한 후 태블릿 화면을 다음의 화면으로 맟추어 놓습니다.<br/>
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_screen_menu.jpg" /></div>
            </div>
            <div class="p-relative section_2" style="width:400px; height:250px;">
                “등하원(학생)” 메뉴를 클릭하면 부모님의 전화번호 뒤부분의 4자리를 이용하여 부모님한테 등하원 문자를 보낼 수 있습니다.<br/>
                <br/>
                선생님이 태블릿과 같은 디바이스에 “등하원(학생)” 화면을 띄워놓으면, 학생들은 스스로 등하원 메시지를 발송할 수 있습니다.

                <div class="p-absolute" style="top:-50px; left:420px;">
                    <img src="@/assets/aca/manual/job/job_checkinout_screen.jpg" />
                </div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="check_by_student_app">
            <div class="ft-b">3)    학생앱에서 등하원 발송</div>
            
            <div class="p-relative section_1">
                - 위의 2)번과 다른 점은 3) 번은 학생이 핸폰을 가지고 다니고 학생앱을 설치하였을때 사용할 수 있는 방법입니다.
            </div>
            <div class="p-relative section_2">
                태블릿을 데스크에 마련한 후 태블릿 화면을 다음의 Qr코드 화면으로 맟추어 놓습니다.<br/>
            </div>
            
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_qr_screen_menu.jpg" /></div>
            </div>

            <p></p>
            <div class="p-relative section_2">
                다음과 같이 Qr코드 화면이 나타나고, 학생앱에서 Qr코드를 찍으면 자동으로 등하원 메시지가 발송됩니다.
            </div>
            <div class="p-relative section_2" style="height:350px;">
                <div><img src="@/assets/aca/manual/job/job_checkinout_qr_screen.jpg" /></div>
                <div class="p-absolute" style="top:0px; left:220px;">
                    <img src="@/assets/aca/manual/job/job_checkinout_qr_app.jpg" />
                </div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="checkinout_message">
            <div class="ft-b">4)    등하원 발송 결과 메시지</div>
            
            <div class="p-relative section_1">
                - 등하원 발송 메시지는 다음과 같습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_result.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="checkinout_center_name">
            <div class="ft-b">5)    등하원 메시지의 학원 이름 수정</div>
            
            <div class="p-relative section_1">
                - 학원이름은 “설정 > 학원정보” 메뉴에서 수정합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_center_name.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="checkinout_message_edit">
            <div class="ft-b">6)    등하원 메시지 문장 수정</div>
            
            <div class="p-relative section_1">
                - 메시지를 바꾸고 싶다면 메뉴의 “설정 > 기초데이터 > 등하원메시지”에서 수정합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/job/job_checkinout_message_edit.jpg" /></div>
            </div>
        </div>

      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '선생님이 등하원 발송', link: '#check_by_teacher' },
                { label: '학생이 등하원 발송', link: '#check_by_student' },
                { label: '학생앱에서 등하원 발송', link: '#check_by_student_app' },
                { label: '등하원 발송 결과 메시지', link: '#checkinout_message' },
                { label: '등하원 메시지의 학원 이름 수정', link: '#checkinout_center_name' },
                { label: '등하원 메시지 문장 수정', link: '#checkinout_message_edit' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


